import * as React from 'react';
import Icon from 'common/components/IconFont';
import { Input, Popover } from 'antd';
import { post } from 'common/utils/request';
import * as intl from "react-intl-universal";
const zxcvbn = require("zxcvbn");

// 渲染静态展示组件
export default class Password extends React.Component<any> {
    state: any = {
        type: 'password',
        value: '',
        tipContent: [],
        popoverWidth: null,
        isFocus: false,
    };
    getWidth: any = null;
    maxLength: number = 16;

    componentDidMount() {
        if (this.getWidth.offsetWidth) {
            // 父级padding用了32
            this.setState({
                popoverWidth: this.getWidth.offsetWidth - 32
            });
        }
    }

    // 修改type类型
    changeType = () => {
        this.state.type === 'password' ? this.setState({ type: 'text' }) : this.setState({ type: 'password' });

    };

    changeHandler = (value: any) => {
        const { onChange } = this.props;
        this.setState({
            value: value.target.value,
        }, () => {
            this.verify();
        });
        onChange && onChange(value, false);
    };

    blurHandler = () => {
        const { onBlur, value } = this.props;
        this.setState({ isFocus: false }, () => {
            onBlur && onBlur(value);
        });
    };

    focusHandler = () => {
        this.setState({ isFocus: true }, () => {
            this.checkPassword().catch();
        });
    };

    // 连续数字或字母校验
    checkContinuity = (str: string = '') => {
        const arr = str.split('').map((x: string) => x && x.charCodeAt(0));
        if (arr.length < 3) return false;
        let isContinuity = false;
        for (let i = 1; i < arr.length; i++) {
            if (
                ((arr[i] >= 48 && arr[i] <= 57) || (arr[i] >= 65 && arr[i] <= 90) || (arr[i] >= 97 && arr[i] <= 122)) &&
                (arr[i] + 1 === arr[i + 1] || arr[i] - 1 === arr[i + 1]) &&
                arr[i] === (arr[i - 1] + arr[i + 1]) / 2
            ) {
                isContinuity = true;
                break;
            }
        }
        return isContinuity;
    };

    timeout: any;
    verify = () => {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.timeout = setTimeout(() => {
            this.checkPassword().catch();
        }, 300);
    };

    // 校验密码强度
    checkPassword = async () => {
        // 默认强度等级为1
        const { level = '1', isVerifiable } = this.props;
        if (!isVerifiable) return;
        const { value } = this.state;
        const lengthReg = (len: number) => new RegExp(`^[A-Za-z\\d!@#$%^&*]{${len},${this.maxLength}}$`);
        const config: any = {
            '0': [
                {
                    tip: intl.get('Validation.PasswordsLeast', { num: 6 }),
                    pass: lengthReg(6).test(value)
                }, {
                    tip: intl.get('Validation.PasswordsDigitsEnglish'),
                    pass: /^(?=.*[A-Za-z])(?=.*\d)/.test(value)
                }
            ],
            '1': [
                {
                    tip: intl.get('Validation.PasswordsLeast', { num: 8 }),
                    pass: lengthReg(8).test(value)
                }, {
                    tip: intl.get('Validation.PasswordsDigitsEnglish'),
                    pass: /^(?=.*[A-Za-z])(?=.*\d)/.test(value)
                }, {
                    tip: intl.get('Validation.PasswordThreeConsecutive'),
                    pass: value && !/([\S])\1{2}/.test(value) && !this.checkContinuity(value)
                }, {
                    tip: intl.get('Validation.PassPasswordCheck'),
                    errTip: intl.get('Validation.PasswordMustCheck'),
                    pass: zxcvbn(value).score >= 2
                },
            ],
            '2': [
                {
                    tip: intl.get('Validation.PasswordsLeast', { num: 9 }),
                    pass: lengthReg(9).test(value)
                }, {
                    tip: intl.get('Validation.PasswordsDigitsEnglish'),
                    pass: /^(?=.*[A-Za-z])(?=.*\d)/.test(value)
                }, {
                    tip: intl.get('Validation.PasswordThreeConsecutive'),
                    pass: value && !/([\S])\1{2}/.test(value) && !this.checkContinuity(value)
                }, {
                    tip: intl.get('Validation.PassPasswordCheck'),
                    errTip: intl.get('Validation.PasswordMustCheck'),
                    pass: zxcvbn(value).score >= 3
                },
            ],
            '3': [
                {
                    tip: intl.get('Validation.PasswordsLeast', { num: 11 }),
                    pass: lengthReg(11).test(value)
                }, {
                    tip: intl.get('Validation.PasswordsDigitsWordEnglishLetters'),
                    pass: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]/.test(value)
                }, {
                    tip: intl.get('Validation.PasswordThreeConsecutive'),
                    pass: value && !/([\S])\1{2}/.test(value) && !this.checkContinuity(value)
                }, {
                    tip: intl.get('Validation.PassPasswordCheck'),
                    errTip: intl.get('Validation.PasswordMustCheck'),
                    pass: zxcvbn(value).score >= 4
                },
            ]
        };
        if (level !== '0' && config[level].slice(0, 3).some(({ pass }: any) => !pass)) config[level][3].pass = false;
        let errItem = config[level].find(({ pass }: any) => !pass);
        // 通过前端校验
        if (level !== '0' && !errItem) {
            const data = await post('/v2/common/password/check', { password: value });
            // 未通过黑名单校验
            if (!data.isPass) {
                config[level][3].pass = false;
            }
        }
        this.setState({
            tipContent: config[level]
        });
    };

    render() {
        const { type, tipContent, popoverWidth, isFocus } = this.state;
        const { placeholder, disabled, showEye = false, initialValue, isVerifiable } = this.props;
        const popoverContent = (
            <div className='tip-content' style={{ width: popoverWidth ? `${popoverWidth}px` : '100%' }}>
                <p>{intl.get('Hint.PasswordMust')}</p>
                <ul>{tipContent.map((item: any, index: number) =>
                    <li key={index}>
                        <i className={item.pass ? 'fail' : 'pass'}>✔</i><span>{item.tip}</span>
                    </li>
                )}</ul>
            </div>
        );
        const inputComponent = (
            <div style={{ position: 'relative' }} className={`${isVerifiable ? 'hide-help' : ''} ${isFocus ? 'isFocus' : ''}`}
                key='getWidth' ref={(dom) => { this.getWidth = dom; }}>
                <Input type={type} autoComplete={'password'}
                    placeholder={placeholder} defaultValue={initialValue || undefined} maxLength={this.maxLength}
                    disabled={disabled} onBlur={this.blurHandler} onFocus={this.focusHandler} onChange={this.changeHandler} />
                {showEye && <Icon className={`anticon-${type === 'password' ? 'eye_open' : 'eye_close'}`} onClick={this.changeType}
                    style={{ position: 'absolute', right: '7px', top: '10px', cursor: 'pointer' }} />}
            </div>
        );
        return isVerifiable
            ? <Popover overlayClassName="V4M-Password-tip" placement="bottomLeft" content={popoverContent} trigger="focus">{inputComponent}</Popover>
            : inputComponent;
    }
}
